import React from 'react';
import PropTypes from 'prop-types';

import Rating from './Rating';

const Reviews = ({ averageRate, count }) => (averageRate
  ? <Rating averageRate={averageRate} count={count} />
  : <span className="first-review-link">Review this product</span>
);

Reviews.propTypes = {
  averageRate: PropTypes.number,
  count: PropTypes.number,
};

export default Reviews;

